/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

// TODO: we might want to make this injectable to support DEV-time non-root URLs.
module.exports = '/__open-stack-frame-in-editor';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scripts/node_modules/react-dev-utils/launchEditorEndpoint.js
// module id = ./node_modules/react-scripts/node_modules/react-dev-utils/launchEditorEndpoint.js
// module chunks = 0